import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class ContractApi {
  static END_POINTS = {
    getContracts: paths.api.users.contracts,
  };

  static getContracts() {
    return XHTTP(ContractApi.END_POINTS.getContracts, {
      method: "get",
    });
  }
}

export default ContractApi;
